import { AdminTableName } from "../../store/tableData/types";

// eslint-disable-next-line import/prefer-default-export
export const hiddenAdminColumns: Record<AdminTableName, string[]> = {
  Datasources: [
    "DbLogin",
    "DbPassword",
    "Type",
    "MaxConcurrentConnections",
    "LoginType",
  ],
  Functions: [],
  Modules: [],
  Roles: [],
  Tables: ["Type"],
  Templates: [
    "Table",
    "TemplateJSON",
    "DataTemplateJSON",
    "PresentationTemplateJSON",
    "TableSchema",
    "TableName",
  ],
  Users: ["PasswordHash", "LastResetPassword", "Salt"],
};
